// extracted by mini-css-extract-plugin
module.exports = {"deg":"styles_deg__363dL","container":"styles_container__3Gm-b","image":"styles_image__2qJVQ"};